import { AllCommunityModule, ClientSideRowModelModule, ModuleRegistry } from 'ag-grid-community';
import {
  ServerSideRowModelApiModule,
  ServerSideRowModelModule,
  SetFilterModule,
} from 'ag-grid-enterprise';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AgGridService {
  constructor() {
    ModuleRegistry.registerModules([
      AllCommunityModule,
      ClientSideRowModelModule,
      ServerSideRowModelModule,
      // refreshServerSide and the other SSRM API functions live in a separate module.
      ServerSideRowModelApiModule,
      SetFilterModule,
    ]);
  }
}
